import React from 'react';
import PhysicalWeight from './PhysicalWeight';
import { normalizeUnit } from './ReceiptUnitSelect';
const n = value => Number(value).toLocaleString('ro-RO', { maximumFractionDigits: 6 });
export default function StockLotDimensions({ geometry: g, quantity, compact = false }) {
  const unit = normalizeUnit(g.um);
  const pieceUnit = ['BUC', 'BUC.', 'BUCATI', 'BUCĂȚI', 'PCS'].includes(unit);
  const factor = Number(g.stock_units_per_m || 1);
  const size = Number(g.length_m);
  if (!(size > 0 && factor > 0)) return <small>{g.location}</small>;
  const physical = Number(quantity || 0) / factor;
  const pieces = physical / size;
  const weightFactor = unit === 'KG' ? factor : g.kg_per_unit;
  if (pieceUnit) return <small>{compact ? `${n(pieces)} buc.` : g.location}</small>;
  if (compact) return <div><small>{n(pieces)} buc. · {n(physical)} {g.dimension_kind === 'sheet' ? 'm²' : 'ML'}
    {Number(weightFactor)>0&&<> · {n(physical*Number(weightFactor))} KG</>}</small></div>;
  return <div><strong>{n(pieces)} buc. × {n(g.bar_length_m || g.length_m)} m{g.dimension_kind==='sheet'&&<> × {n(g.width_m)} m</>}</strong>
    <PhysicalWeight pieces={pieces} length={g.bar_length_m || g.length_m} width={g.width_m} kind={g.dimension_kind} factor={weightFactor}/>
    {g.weight_source==='article'&&unit!=='KG'&&<div><small className="text-muted">Calculat cu conversia actuală din nomenclator: {n(weightFactor)} kg/{g.dimension_kind==='sheet'?'m²':'ML'}.</small></div>}
    {!(Number(weightFactor)>0)&&<div><small className="text-warning-emphasis">Greutate KG: lipsește coeficientul kg/{g.dimension_kind==='sheet'?'m²':'ML'}.</small></div>}
    <small>{g.location}</small></div>;
}
